module.exports = __webpack_public_path__ + "c25b8ecc6642cf39bec1441135f8a4ca.MP3";